/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Cta_BodyInputs */

const en_fw_cta_body = /** @type {(inputs: Fw_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Firefly Wedding episodes every Friday. Bookmark this page and we will keep the schedule and news current.`)
};

const zh_fw_cta_body = /** @type {(inputs: Fw_Cta_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁每周五更新。收藏本站，播出表与新闻会持续更新。`)
};

/**
* | output |
* | --- |
* | "New Firefly Wedding episodes every Friday. Bookmark this page and we will keep the schedule and news current." |
*
* @param {Fw_Cta_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_cta_body = /** @type {((inputs?: Fw_Cta_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Cta_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_cta_body(inputs)
	return zh_fw_cta_body(inputs)
});
export { fw_cta_body as "fw.cta.body" }